<template>
  <div class="lunch">
    <div class="cards__container">
      <div class="cards__single grayblue noheight">
        <p class="cards__title">
          Lunch
        </p>
        <div class="cards__description">
          <p>12:00 PM - 2:00 PM</p>
        </div>
        <div class="cards__location">
          @ Patio del Fauno Lobby
        </div>
      </div>
      <div v-for="(speaker, index) in speakers" :key="index" class="cards__single cerulean" :class="speaker.class">
        <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
        <div v-if="speaker.imgClass" class="circle"></div>
        <div class="cards__speaker">
          <p class="cards__name">{{ speaker.name }}</p>
          <p class="cards__spktitle spkposition" v-if="speaker.position" v-html="speaker.position"></p>
          <p class="cards__spktitle" v-html="speaker.title"></p>
        </div>
        <div class="cards__description">
          <p class="time">{{ speaker.time }}</p>
          <p class="location">{{ speaker.location }}</p>
        </div>
      </div>
    </div>
  </div>
  <div :class="{'modal-show': isModalOpen}" v-if="isModalOpen" class="modal">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <h1 class="speaker">{{ activeCardInfo?.speaker }}</h1>
      <h2 class="title">{{ activeCardInfo?.title }}</h2>
      <p class="description" v-html="activeCardInfo?.description"></p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Day Two Lunch',
  data() {
    return {
      speakers: [
        {
          imgClass: 'blair',
          name: 'Blair LaCorte',
          position: 'Vice Chair of the Board of Directors - Buck Institute for Research on Aging',
          time: '12:00 PM - 1:00 PM',
          location: 'Patio del Fauno'
        },
        {
          imgClass: 'walker',
          name: 'Scott Walker',
          title: 'DNAX',
          position: 'Co-Founder - DNA',
          time: '1:00 PM - 1:30 PM',
          location: 'Patio del Fauno',
        },
        {
          imgClass: 'rustman',
          name: 'Todd Rustman',
          position: 'Managing Partner - Clarity Capital Partners',
          time: '1:30 PM - 2:00 PM',
          location: 'Patio del Fauno',
        },
        {
          name: 'Panel: Investing in Decentralized AI',
          time: '2:00 PM - 2:30 PM',
          location: 'Patio del Fauno',
          class: 'grayblue noheight presenter'
        }
      ],
      cardData: {
      },
      activeCardInfo: null,
      isModalOpen: false
    }
  },
  methods: {
    openModal(cardId) {
      console.log()
      this.activeCardInfo = this.cardData[cardId];
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.activeCardInfo = null;
    }
  },
};
</script>